import { render, staticRenderFns } from "./collectormodel.vue?vue&type=template&id=5a0fdbe6&"
import script from "./collectormodel.vue?vue&type=script&lang=ts&"
export * from "./collectormodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collectormodel.vue"
export default component.exports